"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetStudyReportInfoSyncResponse = exports.UpdateStudyReportInfoResponse = exports.CreateStudyReportInfoResponse = void 0;
class CreateStudyReportInfoResponse {
}
exports.CreateStudyReportInfoResponse = CreateStudyReportInfoResponse;
class UpdateStudyReportInfoResponse {
}
exports.UpdateStudyReportInfoResponse = UpdateStudyReportInfoResponse;
class GetStudyReportInfoSyncResponse {
}
exports.GetStudyReportInfoSyncResponse = GetStudyReportInfoSyncResponse;
//# sourceMappingURL=studyReportInfo.js.map